export const name = '$gzConfirmDialog';
export default function $gzConfirmDialog(
  $mdDialog
) {
  'ngInject';

  // Constants

  // Variables

  // Service
  let service = {
    confirm,
  };

  return service;

  ///////////////
  // Service
  function confirm(locals) {
    return $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: null,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('./confirm-dialog.jade'),
      controller: 'gzConfirmDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals,
    });
  }

  ///////////////
  // Helpers
}
